
import { defineComponent, ref } from "vue";
import InputText from "primevue/inputtext";
import NextStepButton from "@/components/NextStepButton.vue";
import ToggleButton from "primevue/togglebutton";

export default defineComponent({
  name: "DeliveryDetails",
  components: { InputText, NextStepButton, ToggleButton },
  props: {
    isAuthed: {
      type: Boolean,
      default: false,
    },
    isShippingSame: {
      type: Boolean,
      default: false,
    },
    isDIY: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const showShipping = ref(props.isShippingSame);
    const hasAuth = ref(props.isAuthed);
    const login = () => {
      hasAuth.value = true;
      emit("login");
    };
    const createAccount = () => {
      hasAuth.value = true;
      emit("createAccount");
    };
    const forgot = () => {
      emit("forgot");
    };
    return {
      showShipping,
      hasAuth,
      login,
      createAccount,
      forgot,
    };
  },
});
